import type { StateChangeSource } from '../types/StateChangeSource';

/**
 * This file is for tracking the last state change source that modified the folder pane's visibility.
 * This is used to determine certain behaviors like whether Copilot Chat collapsing should re-open the folder pane.
 * As an example: If the reason the folder pane was last collapsed was because the user opened Copilot Chat,
 *                then we want to re-open the folder pane when they close Copilot Chat.
 *                However, if they manually collapsed the folder pane themselves, we respect that and do not re-open.
 */
let lastCollapsedFolderPaneStateChangeSource: StateChangeSource | undefined = undefined;
let lastExpandedFolderPaneStateChangeSource: StateChangeSource | undefined = undefined;

// Last collapsed source, i.e. why Folder Pane was last collapsed
export function setLastCollapsedFolderPaneStateChangeSource(
    source: StateChangeSource | undefined
): void {
    lastCollapsedFolderPaneStateChangeSource = source;
}
export function getLastCollapsedFolderPaneStateChangeSource(): StateChangeSource | undefined {
    return lastCollapsedFolderPaneStateChangeSource;
}

// Last expanded source, i.e. why Folder Pane was last expanded
export function setLastExpandedFolderPaneStateChangeSource(
    source: StateChangeSource | undefined
): void {
    lastExpandedFolderPaneStateChangeSource = source;
}
export function getLastExpandedFolderPaneStateChangeSource(): StateChangeSource | undefined {
    return lastExpandedFolderPaneStateChangeSource;
}
